import dt from 'datatables.net-bs5';
import 'datatables.net-responsive-bs5';

function toggle(className, displayState){
    var elements = document.getElementsByClassName(className);
    for (var i = 0; i < elements.length; i++){
        elements[i].style.display = displayState;
    }
}
function initTable(){

    let table = new dt('.hfs-data-table', {
        "order": [],
        "autoWidth": false,
        "responsive": {
        details: {
            type: 'column',
            target: 'tr'
        }
        },
        "initComplete": function(settings, json) {
            toggle('hfs-spinner', 'none');
            toggle('hfs-table', 'table');
            toggle('hfs-card-nav', 'flex');
        }
    });
    
}
document.addEventListener('DOMContentLoaded', function() {
    $(document).on('click', '.btn-generate-top-10-report', function(e){
        toggle('hfs-spinner', 'block');
        $('.report-data').html('');
        $('.btn-top10-report-pdf').remove();

        let reportUrl = '/reports/top10?display=1&filter='+$('#top10Filter').val();

        $.ajax({
            url: reportUrl,
            method: 'GET',
            success: function(response) {

                let reportButton = `
                    <a href="${reportUrl}&pdf=1" class="btn btn-success btn-top10-report-pdf btn-sm float-end text-white">
                        <i class="fa fa-file-pdf"></i> Download PDF
                    </a>`;

                $('.top-10-header').append(reportButton);

                var newHTML = $(response).find('.report-data').html();
                $('.report-data').html(newHTML);
                initTable();
            }
        })
    })
    
});